module.exports = __webpack_public_path__ + "img/auto_texts_inactive.5ab44336.svg";